export default __webpack_public_path__ + "static/media/josh.db1f2353.png";